import { Menu as MenuCore, MenuBtn, Transition } from '@studiometa/ui';
import MenuList from './MenuList.js';

/**
 * Menu
 */
export default class Menu extends MenuCore {
  static config = {
    ...MenuCore.config,
    emits: ['open', 'close'],
    components: {
      Menu,
      MenuList,
      MenuBtn,
      Transition,
    },
  };

  /**
   * isOpen
   * @returns {boolean}
   */
  get isOpen() {
    return this.menuList?.isOpen ?? false;
  }

  /**
   * onMenuListItemsOpen
   * @param {*} props
   */
  onMenuListItemsOpen(props) {
    super.onMenuListItemsOpen(props);
    this.$emit('open');
  }

  /**
   *
   */
  onMenuListItemsClose() {
    this.$emit('close');
  }
}
